module.exports = __webpack_public_path__ + "static/media/Niveau_elN13_1_773762.89f88dfb.png";